import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import {
  Agency,
  Company,
  Employee,
  Hub,
  User,
} from "@models";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import {
  AgencyService,
  AuthService,
  BookedService,
  CompanyService,
  ConfigService,
  ExcelService,
  GroupService,
  HubService,
  LanguageService,
  MediaService,
  NgxToastrService,
  SearchService,
  TravelService,
  UserService,
  UtilsService,
} from "@services";
import { ProvidersComponent } from "@shared/component/providers/providers.component";
import { AppState } from "app/app.reducer";
import { SendEmailUsersComponent } from "app/modules/businessEntities/user/send-email-users/send-email-users.component";
import { ConfigComponent } from "app/modules/components/config/config.component";
import { GraphComponent } from "app/modules/components/graph/graph/graph.component";
import * as fromAuthActions from "app/store/actions/auth.actions";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import swal from "sweetalert2";
import moment from "moment";
import { ProvidersFunctionComponent } from "@shared/component/providers-function/providers-function.component";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  toggleClass = "ft-maximize";
  placement = "bottom-right";
  public isCollapsed = true;
  @ViewChild("userIcon") userIcon: ElementRef;
  @ViewChild("requestItem") requestItem: ElementRef;
  @Output()
  toggleHideSidebar = new EventEmitter<Object>();
  authenticatedUser: any;
  language: string;
  companyUuid = "";
  hubId;
  partnerId;
  public config: any = {};
  subcriptions: Subscription[] = [];
  groupSubscription: Subscription;
  departments: any[] = [];
  user: User;
  employee: Employee;
  isAdmin = false;
  company: Company;
  agency: Agency;
  hub: Hub;
  canUseTRM: boolean;
  canInvite = false;
  departmentUuid: string;
  canGoLocalsfy: boolean;
  isGroupAdmin = false;
  params: any = {};
  cardImageBase64: string;
  totalAuthorizations = 0;
  isCompany = false;
  isAgency = false;
  isHub = false;
  isEmployee = false;
  isUser = false;
  isLoadingExcel: boolean = false;
  hubImage: string;
  agencyImage: string;
  allTravels: any[] = [];
  subscriptions: Subscription[] = [];

  constructor(
    public translate: TranslateService,
    private configService: ConfigService,
    private store: Store<AppState>,
    private authService: AuthService,
    private langService: LanguageService,
    private modalService: NgbModal,
    private userService: UserService,
    private ngxToastrService: NgxToastrService,
    private bookedService: BookedService,
    private groupService: GroupService,
    private companyService: CompanyService,
    public utilsService: UtilsService,
    private router: Router,
    private mediaService: MediaService,
    private excelService: ExcelService,
    private hubService: HubService,
    private agencyService: AgencyService,
    private travelService: TravelService,
    private searchService: SearchService,
  ) {
    this.getProfile();
    this.params["status"] = "request";
    this.utilsService.imageChanged$.subscribe((image) => {
      if (image && image !== "undefined") {
        this.subcriptions.push(
          this.mediaService.getMedia(image).subscribe((s) => {
            const reader = new FileReader();
            const reader1 = new FileReader();
            reader.readAsDataURL(s);
            let base64data;
            reader.onload = () => {
              base64data = reader.result;
              this.cardImageBase64 = base64data;
            };
            reader1.readAsArrayBuffer(s);
          })
        );
      } else {
        this.cardImageBase64 = null;
      }
    });

    this.utilsService.userChanged$.subscribe((changed) => {
      if (changed) {
        this.authService.getProfile().subscribe((res: User) => {
          this.authenticatedUser = res;
        });
      }
    });
  }

  ngOnInit() {
    this.language = this.langService.getLanguage();
    this.config = this.configService.templateConf;
    this.subcriptions.push(
      this.store.select("auth").subscribe((u: any) => {
        this.authenticatedUser = u.user;
        if (u.user && u.user.type?.toUpperCase() === "USER") {
          this.user = u.user;
          this.isUser = true;
          this.canUseTRM = u.user.type
            ? u.user.plan && u.user.plan.permissions.canUseTRM
            : u.user.user.plan && u.user.user.plan.permissions.canUseTRM;
          if (this.user.isGroupAdmin) {
            this.getAuthorizationList();
          }
        } else if (
          u.user &&
          (u.user.type
            ? u.user.type?.toUpperCase() === "COMPANY"
            : u.user.user.accessType?.toUpperCase() === "COMPANY")
        ) {
          this.companyUuid = u.user.companyUuid;
          this.canUseTRM = u.user.type
            ? u.user.plan && u.user.plan.permissions.canUseTRM
            : u.user.user.plan && u.user.user.plan.permissions.canUseTRM;
          this.canInvite = !this.canUseTRM;
          this.company = u.user;
          this.isCompany = true;
          this.departmentUuid = u.user.departmentUuid
            ? u.user.departmentUuid
            : u.user.user.departmentUuid;
          this.canGoLocalsfy = u.user.type
            ? u.user.plan && u.user.plan.permissions.canUseLocalsfy
            : u.user.user.plan && u.user.user.plan.permissions.canUseLocalsfy;
          this.getAuthorizationList();
        } else if (
          u.user &&
          (u.user.type
            ? u.user.type?.toUpperCase() === "AGENCY"
            : u.user.user.accessType?.toUpperCase() === "AGENCY")
        ) {
          this.agency = u.user;
          this.canUseTRM = u.user.type
            ? u.user.plan && u.user.plan.permissions.canUseTRM
            : u.user.user.plan && u.user.user.plan.permissions.canUseTRM;
          this.canInvite = !this.canUseTRM;
          this.isAgency = true;
          this.canGoLocalsfy = u.user.type
            ? u.user.plan && u.user.plan.permissions.canUseLocalsfy
            : u.user.user.plan && u.user.user.plan.permissions.canUseLocalsfy;
          const agencyUuid = u.user.agencyUuid || u.user.user.agencyUuid;
          this.agencyService.getAgency(agencyUuid).subscribe(
            (agency: Agency) => {
              this.agencyImage = agency.image
              let profileImage;
              if (u.user.user) {
                profileImage = u.user.user.image;
              } else {
                profileImage = u.user.image;
              }
              if (profileImage) {
                this.subcriptions.push(
                  this.mediaService.getMedia(profileImage).subscribe((s) => {
                    const reader = new FileReader();
                    const reader1 = new FileReader();
                    reader.readAsDataURL(s);
                    let base64data;
                    reader.onload = () => {
                      base64data = reader.result;
                      this.cardImageBase64 = base64data;
                    };
                    reader1.readAsArrayBuffer(s);
                  })
                );
              }
            }
          );
        } else if (
          u.user &&
          (u.user.type
            ? u.user.type?.toUpperCase() === "HUB"
            : u.user.user.accessType?.toUpperCase() === "HUB")
        ) {
          this.hub = u.user;
          this.canUseTRM = u.user.type
            ? u.user.plan && u.user.plan.permissions.canUseTRM
            : u.user.user.plan && u.user.user.plan.permissions.canUseTRM;
          this.canInvite = !this.canUseTRM;
          this.isHub = true;
          this.canGoLocalsfy = u.user.type
            ? u.user.plan && u.user.plan.permissions.canUseLocalsfy
            : u.user.user.plan && u.user.user.plan.permissions.canUseLocalsfy;
          const hubUuid = u.user.hubUuid || u.user.user.hubUuid;

          this.hubService.getHub(hubUuid).subscribe(
            (hub: Hub) => {
              this.hubImage = hub.image
              let profileImage;
              if (u.user.user) {
                profileImage = u.user.user.image;
              } else {
                profileImage = u.user.image;
              }
              if (profileImage) {
                if (this.hubImage) {
                  this.subcriptions.push(
                    this.mediaService.getMedia(profileImage).subscribe((s) => {
                      const reader = new FileReader();
                      const reader1 = new FileReader();
                      reader.readAsDataURL(s);
                      let base64data;
                      reader.onload = () => {
                        base64data = reader.result;
                        this.cardImageBase64 = base64data;
                      };
                      reader1.readAsArrayBuffer(s);
                    })
                  );
                }
              }
            }
          );
        } else if (
          u.user &&
          (u.user.type
            ? u.user.type?.toUpperCase() === "EMPLOYEE"
            : u.user.user.accessType?.toUpperCase() === "EMPLOYEE")
        ) {
          this.employee = u.user;
          this.isEmployee = true;
          this.canUseTRM = u.user.type
            ? u.user.plan && u.user.plan.permissions.canUseTRM
            : u.user.user.plan && u.user.user.plan.permissions.canUseTRM;
          this.canInvite = !this.canUseTRM;
          this.canGoLocalsfy = u.user.type
            ? u.user.plan && u.user.plan.permissions.canUseLocalsfy
            : u.user.user.plan && u.user.user.plan.permissions.canUseLocalsfy;
        }

        if (u.user && u.user.image && u.user.image !== "undefined") {
          let profileImage;
          if (u.user.user) {
            profileImage = u.user.user.image;
          } else {
            profileImage = u.user.image;
          }
          if (profileImage) {
            this.subcriptions.push(
              this.mediaService.getMedia(profileImage).subscribe((s) => {
                const reader = new FileReader();
                const reader1 = new FileReader();
                reader.readAsDataURL(s);
                let base64data;
                reader.onload = () => {
                  base64data = reader.result;
                  this.cardImageBase64 = base64data;
                };
                reader1.readAsArrayBuffer(s);
              })
            );
          }
        }
      })
    );
    this.subscriptions.push(
      this.utilsService.user$.subscribe((user) => {
        if (user) {
          this.authenticatedUser = user;
        }
      })
    );
  }

  ngAfterViewInit() {
    if (this.config.layout.dir) {
      const dir = this.config.layout.dir;
      if (dir === "rtl") {
        this.placement = "bottom-left";
      } else if (dir === "ltr") {
        this.placement = "bottom-right";
      }
    }
    const btn = document.querySelector("nav-biuwer");
    if (btn) {
      btn.classList.remove('feature-highlight');
    }
  }

  getAuthorizationList() {
    const company: any = this.company;
    if (
      (this.user && this.user.accessType?.toLowerCase() === "company") ||
      (company && company.accessType?.toLowerCase() === "agency")
    ) {
      this.params["companyUuid"] = this.user.companyUuid;
    }
    if (
      (this.user && this.user.isGroupAdmin) ||
      (company && company.isGroupAdmin)
    ) {
      this.params["departmentUuid"] =
        this.authenticatedUser.departmentUuid;
    }
    this.subcriptions.push(
      this.bookedService.getAuthorization(this.params).subscribe((result) => {
        if (result && result.length > 0) {
          const requestAuths = result.filter(
            (authorization) => authorization.status === "request"
          );
          if (requestAuths.length > 0) {
            this.authService.totalAuthorizations = result.length;
            this.utilsService.haveRequest = true;
          } else {
            this.utilsService.haveRequest = false;
          }
        } else {
          this.authService.totalAuthorizations = 0;
          this.utilsService.haveRequest = false;
        }
      })
    );
  }
  toggleSidebar() {
    const appSidebar = document.getElementsByClassName("app-sidebar")[0];
    if (appSidebar.classList.contains("hide-sidebar")) {
      this.toggleHideSidebar.emit(false);
    } else {
      this.toggleHideSidebar.emit(true);
    }
  }

  toggleNavbar() {
    const optionsNav = document.getElementsByClassName("options")[0];
    if (optionsNav.classList.contains("show-options")) {
      optionsNav.classList.remove("show-options");
    } else {
      optionsNav.classList.add("show-options");
    }
  }

  logout() {
    const action = new fromAuthActions.LogoutAction();
    this.store.dispatch(action);
    this.authService.userCompanyPlan = null;
    localStorage.removeItem("biuwer")
    localStorage.removeItem;
  }

  getProfile() {
    this.authService
      .getProfile()
      .subscribe((res: User | Employee | Company | Agency | Hub) => {
        this.authenticatedUser = res;
        this.isGroupAdmin =
          res.type === "USER" && res.isGroupAdmin ? res.isGroupAdmin : false;
      });
  }
  onEditUser(department: any) {
    const navigationUser: NavigationExtras = {
      state: {
        loading: false,
        company: this.company,
        department: department,
        user: this.authenticatedUser,
        fromCompanyDetails: true,
      },
    };

    if (this.authenticatedUser.accessType?.toLowerCase() === "agency") {
      navigationUser.state['agency'] = this.authenticatedUser.uuid;
    }

    if (this.authenticatedUser.accessType?.toLowerCase() === "hub") {
      navigationUser.state['hub'] = this.authenticatedUser.uuid;
    }

    this.router.navigate(["user/user-profile"], navigationUser);
  }

  onEditCompany() {
    this.subcriptions.push(
      this.companyService
        .getCompany(this.companyUuid)
        .subscribe((company: Company) => {
          this.company = company;
          const extras: NavigationExtras = {
            state: {
              loading: false,
              company: this.company,
              maxHotelPercentage: 100,
              maxFlightPercentage: 100,
            },
          };
          this.router.navigate(["/my-company/edit-company/"], extras);
        })
    );
  }

  onSendEmailUser() {
    const modalRef = this.modalService.open(SendEmailUsersComponent, {
      size: "lg",
      centered: true,
    });
    modalRef.componentInstance.loading = false;
    modalRef.componentInstance.companyData = this.company;
    modalRef.componentInstance.userData = this.authenticatedUser;
    modalRef.componentInstance.departments = null;

    this.companyService.getPoliciesCompany(this.company.uuid).subscribe(
      (policies) => {
        modalRef.componentInstance.policies = Array.isArray(policies) ? policies : [];
      },
      () => {
        modalRef.componentInstance.policies = [];
      }
    );

    modalRef.componentInstance.sendInfo.subscribe(
      (data) => {
        modalRef.componentInstance.loading = true;

        const body = {
          emailList: data.emails,
          companyUuid: this.company.uuid,
          departmentUuid: data.group ? data.group : this.departmentUuid,
          accessType: data.accessType,
          authorUuid: this.authenticatedUser.uuid,
          policyUuid: data.policy || null,
          notifications: data.notifications
        };

        this.userService.sendEmailsExternalUsers(body).subscribe(
          () => {
            modalRef.componentInstance.loading = false;
            modalRef.dismiss();
            this.translate
              .get([
                'common.understood',
                'company.company-detail.user-external.email-pass',
                'company.company-detail.user-external.subtitle',
              ])
              .subscribe((result) => {
                swal
                  .fire({
                    html: `<div id="understood-container" style="display: flex; flex-direction: column"><p>${result['company.company-detail.user-external.subtitle']}</p><img data-enlargeable src="assets/img/examples/trm/user-enabled.png" alt="Imagen ejemplo de usuario habilitado"/></div>`,
                    allowOutsideClick: false,
                    confirmButtonText: result['common.understood'],
                    title: result['company.company-detail.user-external.email-pass'],
                  })
                  .then(() => this.loadGroups(this.company.uuid));
              });
          },
          (err) => {
            modalRef.componentInstance.loading = false;
            this.translate
              .get('hub.hub-detail.error-created-user')
              .subscribe((result) => this.ngxToastrService.typeInfo(result, err?.error?.message));
          }
        );
      },
      (err) => {
        modalRef.componentInstance.loading = false;
        this.translate
          .get('hub.hub-detail.error-created-user')
          .subscribe((result) => this.ngxToastrService.typeInfo(result, err?.error?.message));
      }
    );
  }

  loadGroups(uuid) {
    this.groupSubscription = this.groupService
      .getGroups(uuid)
      .pipe(take(1))
      .subscribe(
        (departments: any[]) => {
          this.departments = departments;
        },
        (err) => {
          this.translate
            .get("company.company-detail.error-get-groups")
            .pipe(take(1))
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(result, err.error.error);
            });
        }
      );
  }
  // Cambio el idioma de la aplicacion
  changeLanguage(language: string) {
    this.language = language;
    this.translate.use(language);
    this.langService.saveLanguage(language);
  }

  // goToAuthorizations() {
  //   const route = "my-company/requests"
  //   this.router.navigateByUrl(route);
  // }

  openUserStorage() {
    const navigationextras: NavigationExtras = {
      state: {
        user: this.user,
      },
    };
    this.router.navigate(["/user/my-documents"], navigationextras);
    // const dialogRef = this.dialog.open(DialogUserFilesComponent, {height: '90vh', width: '90vw', data: {user: userRes}});
  }

  // goToAHubPartners(){
  //   if(this.router.url.includes("agencies") && this.router.url.includes("hubs")){
  //     this.hubId = this.router.url.split("/")[2];
  //   }
  //   this.router.navigate(["/hubs/"+this.hubId+"/agencies"]);
  // }

  // goToAPartnerCompanies(){
  //   if(this.router.url.includes("agencies") && this.router.url.includes("companies")){
  //     this.partnerId = this.router.url.split("/")[2];
  //   }
  //   this.router.navigate(["/agencies/"+this.partnerId+"/companies"]);
  // }

  openGraphModal(name, type, graphic, uuid) {
    const modalRef = this.modalService.open(GraphComponent, {
      size: "lg",
      centered: true,
    });
    modalRef.componentInstance.name = name;
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.graphic = graphic;
    if (uuid) {
      modalRef.componentInstance.uuid = uuid;
    }
  }

  goToDashboard(isSuperadmin: boolean) {
    const dataDashboard = {
      isSuperAdmin: isSuperadmin,
      accessType: this.authenticatedUser.type?.toLowerCase()
    };
    if (!isSuperadmin) {
      const company: any = this.company;
      dataDashboard["uuid"] = this.company ? company.company.uuid : this.agency.uuid;
      dataDashboard["name"] = this.company ? company.company.name: this.agency.name;
      const url = this.authenticatedUser.type?.toLowerCase() === "company" ? (isSuperadmin
        ? "companies/dashboard"
        : "companies/" + this.companyUuid + "/dashboard") : (isSuperadmin
          ? "agencies/dashboard"
          : "agencies/" + this.agency.uuid + "/dashboard")
      this.router.navigateByUrl(
        url,
        {
          state: { dataDashboard },
        }
      );
    } else {
      this.router.navigateByUrl("dashboard")
     }
  }

  editConfig() {
    const modalRef = this.modalService.open(ConfigComponent, {
      size: "lg",
      centered: true,
    });
    modalRef.componentInstance.sendInfo.subscribe((configInfo) => {
      modalRef.componentInstance.loading = true;
      modalRef.dismiss("send info");
    });
  }

  editProviders() {
    const modalRef = this.modalService.open(ProvidersComponent, {
      size: "lg",
      centered: true,
    });
    modalRef.componentInstance.sendInfo.subscribe((configInfo) => {
      modalRef.componentInstance.loading = true;
      modalRef.dismiss("send info");
    });
  }

  exportExcel() {
    this.getAllTravels();
    this.isLoadingExcel = true
    this.companyService.getAllCompaniesBookeds().subscribe(
      (res) => {
        Object.keys(res).forEach((key) => {
          res[key] = res[key].filter((e) => {
            if (key === "bookings") {
              return e.checkIn && e.checkOut &&
                moment(e.checkIn).isValid() &&
                moment(e.checkOut).isValid();
            }
            if (key === "flights" || key === "trains" || key === "cars") {
              return e.departDate && moment(e.departDate).isValid() &&
                (!e.returnDate || moment(e.returnDate).isValid());
            }
            if (key === "expenses") {
              return e.beginDate && moment(e.beginDate).isValid() &&
                (!e.endDate || moment(e.endDate).isValid());
            }
            return true;
          });
        });
        Object.keys(res).forEach((key) => {
          res[key] = this.associateTravelsWithBookings(res[key], this.allTravels, key);
        });
        this.excelService.createBookingsExcel("Todas las empresas", res);
        this.isLoadingExcel = false
      },
      (err) => {
        this.translate
          .get("graph.error-downloading")
          .subscribe((result) => {
            this.ngxToastrService.typeInfo(result, err.error.message);
          });
        this.isLoadingExcel = false
      }
    );
  }

  getAllTravels() {
    this.travelService.getTravelsFullList().subscribe(res => {
      this.allTravels = res;
    });
  }

  associateTravelsWithBookings(bookingsExcel, travelsExcel, type): any[] {

    const travelUuidsMap = {
      'hotel': ['bookingUuids', 'bookingFromModule', 'customBookingUuids'],
      'bookings': ['bookingUuids', 'bookingFromModule', 'customBookingUuids'],
      'flight': ['flightUuids'],
      'flights': ['flightUuids'],
      'train': ['trainUuids'],
      'trains': ['trainUuids'],
      'car': ['carUuids'],
      'cars': ['carUuids'],
      'expense': ['expenseUuids'],
      'expenses': ['expenseUuids']
    };

    const uuidsToCheck = travelUuidsMap[type] || [];
    const findTravelTitle = (booked, travel) => {
      for (let uuidType of uuidsToCheck) {
        if (travel[uuidType] && travel[uuidType].some(uuid => uuid.uuid ? uuid.uuid === booked.uuid : uuid === booked.uuid)) {
          booked.travelTitle = travel.title;
          return true;
        }
      }
      return false;
    };

    bookingsExcel.forEach(booked => {
      travelsExcel.some(travel => findTravelTitle(booked, travel));
    });

    return bookingsExcel;
  }

  goMainPage() {
    localStorage.removeItem('packageRateAccomInfo');
    localStorage.removeItem('packageRateFlightInfo');
    localStorage.removeItem('isPackageRate')
    if (this.authenticatedUser.type?.toUpperCase() === "USER") {
      this.router.navigate(["/home"]);
    } else if (this.authenticatedUser.type?.toUpperCase() === "COMPANY") {
      if (this.authService.userCompanyPlan.permissions.canUseTRM) {
        this.router.navigate(["/my-company/details"]);
      } else {
        this.router.navigate(["/home"]);
      }
    } else {
      this.router.navigate(["/companies"]);
    }
  }

  goToRequests() {
    this.router.navigate([
      `/companies/${this.user.companyUuid}/authorizations`,
    ]);
  }

  navigate(url: string) {
    this.router.navigateByUrl(url);
  }

  goToStats() {
    this.router.navigate([
      `/stats`,
    ]);
  }

  openProvidersModal() {
    const modalRef = this.modalService.open(ProvidersFunctionComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.result
      .then(() => {})
      .catch(() => {});
  }

  ngOnDestroy() {
    if (this.subcriptions) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    this.utilsService.clearUserData();
  }

  updateExpediaHotels() {
    this.searchService.updateStaticData().subscribe((res) => console.log(res), (error) => console.log(error))
  }
}
